/**
 * MessageNavigator - Navigation controls for thread messages
 *
 * Prev/next/start/end buttons with position counter.
 */

interface MessageNavigatorProps {
  currentIndex: number;
  totalCount: number;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
}

export function MessageNavigator({
  currentIndex,
  totalCount,
  onFirst,
  onPrev,
  onNext,
  onLast,
}: MessageNavigatorProps) {
  const isFirst = currentIndex === 0;
  const isLast = currentIndex >= totalCount - 1;

  return (
    <div className="message-nav">
      <button
        className="message-nav__btn"
        onClick={onFirst}
        disabled={isFirst}
        aria-label="First message"
      >
        ⏮
      </button>
      <button
        className="message-nav__btn"
        onClick={onPrev}
        disabled={isFirst}
        aria-label="Previous message"
      >
        ◀
      </button>
      <span className="message-nav__counter">
        {currentIndex + 1}/{totalCount}
      </span>
      <button
        className="message-nav__btn"
        onClick={onNext}
        disabled={isLast}
        aria-label="Next message"
      >
        ▶
      </button>
      <button
        className="message-nav__btn"
        onClick={onLast}
        disabled={isLast}
        aria-label="Last message"
      >
        ⏭
      </button>
    </div>
  );
}
